import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../../app.constant';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { BatchService } from 'src/app/shared/services/batch.service';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { SubjectService } from 'src/app/shared/services/subject.service';
import { DecisionService } from 'src/app/shared/services/decision.service';
import { Router } from "@angular/router";
import { MatSnackBar} from '@angular/material';
import { Program } from 'src/app/shared/class/program';

@Component({
  selector: 'app-decision',
  templateUrl: './decision.component.html',
  styleUrls: ['./decision.component.css']
})

export class DecisionComponent implements OnInit {
  batches:any;
    selectedFile: File = null;
    errorMessage:any;
    decisionForm:FormGroup;
    programs:any;
    module:any;
    modules:any;
    post :any;
    data:any;
 
    httpResponseMessage:any;
    PK_ProgramID:any=null;
    FK_BatchID:any=null;
    FK_ProgramID:any=null;
    FK_ModuleID:any=null;
    FK_SubjectID:any=null;
    
    selectedProgram:Program = new Program (1,'ABC','asd','sadasdsa');
    program:any;

    
  constructor(
    private formbuilder:FormBuilder,
    private _batchservice:BatchService,
    private _programservice:ProgramService,
    private _moduleservice:ModuleService,
    private _decisionervice:DecisionService,
    private snackBar: MatSnackBar,
    private router: Router) { }

    ngOnInit() {
      this.decisionForm =this.formbuilder.group( {
       'FK_BatchID':['', Validators],
       'FK_ProgramID':['', Validators],
       'FK_ModuleID':['', Validators],
        })
        this.getAllProgram();
        this.getAllBatch();
     }

  getAllBatch() :void  {
    this._batchservice.getAllBatch(AppSettings.API_ENDPOINT+AppSettings.GetAllBatch).subscribe(
     data => {    this.batches=data;
       },
     error => this.errorMessage = <any>error)
  }

  getAllProgram() :void  {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT+AppSettings.GetAllProgram).subscribe(
      data => {
           this.programs=data;
      },
      error => this.errorMessage = <any>error)
    }

  getModuleByProgramID(PK_ProgramID) :void  {
    this.PK_ProgramID=PK_ProgramID;
    this._moduleservice.getAllModule(AppSettings.API_ENDPOINT+AppSettings.GetAllModule).subscribe(
    data =>
      {
        this.module=data;
        this.modules= this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
   },
   error => this.errorMessage = <any>error)
    }



    UpdateDecision(post) :void  {
        this.post=JSON.stringify(post);
         this._decisionervice.updateDecision(AppSettings.API_ENDPOINT+AppSettings.UpdateDecisionByParam,this.post).subscribe(
          data => {
           console.log(data);
           this.httpResponseMessage="Marksheet  Uploaded...."
           this.openSnackBar(this.httpResponseMessage,'');
           this.decisionForm.reset();
            },
          error => this.errorMessage = <any>error)
       }

        durationInSeconds = 2;
        openSnackBar(message: string, action: string) {
          this.snackBar.open(message,action ,{
            duration: 2000,
            verticalPosition: 'bottom'
          });
          }
}
